module.exports = __webpack_public_path__ + "img/unlock.78d3cc06.svg";